import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./SubscriptionManagementReducer";
import {
  resetPageAndLimit,
  resetSearchFilters,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
} from "../YouTubeManagement/YouTubeManagementActions";

export function getPaymentReceiptList(data, page, limit, undefined, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_PAYMENT_RECEIPT_LIST_PENDING,
      payload: {
        getPaymentReceiptListPending: true,
        getPaymentReceiptListSuccess: false,
        getPaymentReceiptListError: null,
        paymentReceiptList: [],
      },
    });
    dispatch(showLoader());

    Api.post(`profile/paymentReceipt?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_PAYMENT_RECEIPT_LIST_SUCCESS,
          payload: {
            getPaymentReceiptListPending: false,
            getPaymentReceiptListSuccess: true,
            getPaymentReceiptListError: null,
            paymentReceiptList: response.data,
            currentPageOfTransactionHistory: response.data?.page,
            rowsPerPageOfTransactionHistory: response.data?.limit,
          },
        });
        dispatch(resetPageAndLimit());
        dispatch(resetSearchFilters());
        dispatch(resetActiveNavigationTab());
        dispatch(resetSearchFilterForVideosByUrl());
        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_PAYMENT_RECEIPT_LIST_ERROR,
          payload: {
            getPaymentReceiptListPending: false,
            getPaymentReceiptListSuccess: false,
            getPaymentReceiptListError: null,
            paymentReceiptList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function updateCurrentPageAndRowLimit(data) {
  const { currentPageOfTransactionHistory, rowsPerPageOfTransactionHistory } =
    data;
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CURRENT_PAGE_AND_ROW_LIMIT,
      payload: {
        currentPageOfTransactionHistory: currentPageOfTransactionHistory,
        rowsPerPageOfTransactionHistory: rowsPerPageOfTransactionHistory,
      },
    });
  };
}

export function updateSearchFilters(data) {
  // console.log("data", data);
  const { notificationType } = data;
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_SEARCH_FILTERS,
      payload: {
        searchFilters: {
          notificationType: notificationType,
        },
      },
    });
  };
}
